export default __webpack_public_path__ + "static/media/Logo_Cleanproplus-blue.97c5711c.png";